import React, { useRef, useEffect, useState } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { WidgetCard } from '../WidgetCard';
import { Popup, Dropdown } from 'semantic-ui-react';
import { widgetHeight, widgetWidth } from '..';
import { BottomButtonRow, Message, CardBodyWrapper } from '../Styles';
import ButtonWithConfirmation from '../ButtonWithConfirmation';
import useStores from '../../../../hooks/use-store';
import { useAuctionAndLanes } from '../Streamer/SwitchStreamerWidget';
import { engineToolType } from '../../../../stores/reducers/engineTools';

export const EngineResetAuctionWidget = observer(() => {
  const {
    AuctionStore: { sortedActiveAuctions, getSortedActiveAuctions },
    EngineToolStore: { enginePost: post, widgetReloading },
  } = useStores();

  const key = 'reset-auction';

  const { onAuctionChanged, auction, isLoadingAuctions, auctions } =
    useAuctionAndLanes({
      sortedActiveAuctions,
      getSortedActiveAuctions,
      enableLaneLoading: false,
    });

  const [message, setMessage] = useState(null);
  const [success, setSuccess] = useState(null);

  const statusMessageHandler = ({ success, message }) => {
    setMessage(message);
    setSuccess(success);
  };

  const handleConfirmation = (e) => {
    e.preventDefault();
    post(engineToolType.resetAuction, { auctionID: auction.auctionId }).then(
      statusMessageHandler,
    );
  };

  const isLoading =
    isLoadingAuctions || widgetReloading[engineToolType.resetAuction];

  console.log('auction', auction);
  return (
    <WidgetCard
      heading="Reset Auction"
      description="Resets an Auction back to a Pre-Auction state."
      width="450px"
      height="235px"
    >
      <CardBodyWrapper>
        <Dropdown
          placeholder="Select Auction"
          clearable
          fluid
          selection
          options={auctions}
          onChange={(e, data) => {
            onAuctionChanged(data.value, e.currentTarget.textContent);
            statusMessageHandler({ success: null, message: null });
          }}
          disabled={isLoading}
        />
      </CardBodyWrapper>
      <BottomButtonRow buttonWidth="150px">
        {message ? (
          <Popup
            data-testid={`${key}-popup`}
            key={key}
            content={message}
            header="Details"
            size="small"
            trigger={
              <Message success={success}>
                {success
                  ? '😃 The auction has been successfully reset!'
                  : '🤔 Oops, an error occurred while trying to reset the auction.'}
              </Message>
            }
          />
        ) : (
          <Message />
        )}
        <ButtonWithConfirmation
          buttonText="Reset Auction"
          buttonIcon="sync"
          onConfirmation={handleConfirmation}
          loading={isLoading}
          disabled={!auction?.auctionId}
        />
      </BottomButtonRow>
    </WidgetCard>
  );
});

export default EngineResetAuctionWidget;
